const batchStatus = Object.freeze({
  PENDING: 'Pending',
  VALIDATED: 'Validated',
  STAGE_1_IN_PROGRESS: 'Stage1InProgress',
  STAGE_1_DONE: 'Stage1Done',
  STAGE_2_IN_PROGRESS: 'Stage2InProgress',
  COMPLETE: 'Complete',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled'
});

// Colour tokens locked during 2026-05-19 design session
const GREEN = { bgColor: '#DCEBE0', textColor: '#4A9A65' };
const PEACH = { bgColor: '#FBE2C8', textColor: '#C97A30' };
const CORAL = { bgColor: '#F5D6D9', textColor: '#C25461' };
const GREY = { bgColor: '#ECECEC', textColor: '#777777' };

const batchStatusConfig = Object.freeze({
  [batchStatus.PENDING]: {
    ...GREY,
    label: 'Pending',
    subtext: "Waiting for Hub's validation email"
  },
  [batchStatus.VALIDATED]: {
    ...GREEN,
    label: 'Validated',
    subtext: 'Ask Hub team to trigger Stage 1'
  },
  [batchStatus.STAGE_1_IN_PROGRESS]: {
    ...PEACH,
    label: 'Stage 1 in progress',
    subtext: "Waiting for Hub's Stage 1 result email"
  },
  [batchStatus.STAGE_1_DONE]: {
    ...GREEN,
    label: 'Stage 1 done',
    subtext: 'Ask Hub team to trigger Stage 2'
  },
  [batchStatus.STAGE_2_IN_PROGRESS]: {
    ...PEACH,
    label: 'Stage 2 in progress',
    subtext: "Waiting for Hub's Stage 2 result email"
  },
  [batchStatus.COMPLETE]: {
    ...GREEN,
    label: 'Complete',
    subtext: 'Migration finished'
  },
  [batchStatus.FAILED]: {
    ...CORAL,
    label: 'Failed',
    subtext: 'Re-upload corrected CSVs'
  },
  [batchStatus.CANCELLED]: {
    ...GREY,
    label: 'Cancelled',
    subtext: 'Batch abandoned — use Set Status to resume'
  }
});

// Order in which statuses appear in the Set Status menu — Cancelled is reached via the dedicated Cancel batch action.
const journeyStatusOrder = Object.freeze([
  batchStatus.PENDING,
  batchStatus.VALIDATED,
  batchStatus.STAGE_1_IN_PROGRESS,
  batchStatus.STAGE_1_DONE,
  batchStatus.STAGE_2_IN_PROGRESS,
  batchStatus.COMPLETE,
  batchStatus.FAILED
]);

export default batchStatus;
export { batchStatusConfig, journeyStatusOrder };
